
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as indexrMM2pb1xNKpc9dn0El6FwInZ7F8HIHFEh6lVMb_KLsUMeta } from "/opt/buildhome/repo/pages/orders/index.vue?macro=true";
import { default as indexrwqM7p3OuU3Ztj3GCs6JqQ5LFsGdjXittiNCCHqX9ioMeta } from "/opt/buildhome/repo/pages/orders/[orderId]/index.vue?macro=true";
import { default as _91page_93oqpdt1K9GN_GVD5nfe_LeJK8JNTkFQy1xe6rfDJu9YkMeta } from "/opt/buildhome/repo/pages/orders/[orderId]/[page].vue?macro=true";
import { default as indexZDTZiiCCBrjHIwiaE7pzOTJz6nNQbI3Ae28xfoRkUNUMeta } from "/opt/buildhome/repo/pages/orders/[orderId]/vouchers/[voucherId]/index.vue?macro=true";
import { default as _91page_93KoNHyYz5hpyqpFNaMFYoUYdDaJRFdWVjMLPckG82rroMeta } from "/opt/buildhome/repo/pages/orders/[orderId]/vouchers/[voucherId]/[page].vue?macro=true";
import { default as ordersbykzvWgceilKkMpFXAx0hhlDa7s_45ZHIPIATLTDuLIt8Meta } from "/opt/buildhome/repo/pages/orders.vue?macro=true";
import { default as indexRvcdmEwL4RFePdJquzx3GIdL2XW28HDR_45fRgC4zdxO4Meta } from "/opt/buildhome/repo/pages/stores/index.vue?macro=true";
import { default as interstitial1YMJc8qq01O1rHPDK2A_45o0e5XlKPWlgJQZ3ukNzoRlQMeta } from "/opt/buildhome/repo/pages/stores/interstitial.vue?macro=true";
import { default as faqZyRpwmgDVQHcY_45QwRz_45_ObvY7155rTN5zjue1jFjbs0Meta } from "/opt/buildhome/repo/pages/stores/create/[type]/faq.vue?macro=true";
import { default as indexLCZBschpqO4WF5ljaEHIoB77_1KCJNaHqA7vhSenUpEMeta } from "/opt/buildhome/repo/pages/stores/create/[type]/index.vue?macro=true";
import { default as termshu1DTp60iPQALH9dlWIHJ0fIC8Jer_DbpY_IAICZN_AMeta } from "/opt/buildhome/repo/pages/stores/create/[type]/terms.vue?macro=true";
import { default as faqhYp6OK5mx6DN1sWPoWZKVKhmklU7jmFfc5ToFtEUIMcMeta } from "/opt/buildhome/repo/pages/stores/[salesChannelId]/faq.vue?macro=true";
import { default as designNxwY9NmAGZyiGRe3m2YbInA7h_cZ4D48DF_45jW5m9r6QMeta } from "/opt/buildhome/repo/pages/stores/create/[type]/design.vue?macro=true";
import { default as privacyVg1dQrvhesF6662X6uA1CFUnaZSogYl8C5pDNbHdHrcMeta } from "/opt/buildhome/repo/pages/stores/create/[type]/privacy.vue?macro=true";
import { default as indexrLiCHEnuQb9je3YHnR9PDqjyXRtbp_45x8Rh9esa25RCMMeta } from "/opt/buildhome/repo/pages/stores/[salesChannelId]/index.vue?macro=true";
import { default as termsJ5X0hUqtwGnICPSK8nOUgBuHnePbacGKb_0gvcNtcwAMeta } from "/opt/buildhome/repo/pages/stores/[salesChannelId]/terms.vue?macro=true";
import { default as designUkbbtULvqdOaURc5POH9g2lv1eFf_45BcJDZNW_45eo_45P2cMeta } from "/opt/buildhome/repo/pages/stores/[salesChannelId]/design.vue?macro=true";
import { default as privacyHyBTvdUqWFrxGzS6Th1LlguAijuvv9ja2sibWUmnrV8Meta } from "/opt/buildhome/repo/pages/stores/[salesChannelId]/privacy.vue?macro=true";
import { default as indexYYG5tNwqkUMkE29_45U80Fh0103gmb4FIYnKvhtllAt54Meta } from "/opt/buildhome/repo/pages/stores/create/[type]/emails/index.vue?macro=true";
import { default as _91page_93HKbZPdBEQn2KuggbN2N05ygjGFqpLOy3P250FaS_dVAMeta } from "/opt/buildhome/repo/pages/stores/create/[type]/emails/[page].vue?macro=true";
import { default as voucher_45codesMyF_45HxtONrG58W1HcR5Co_2FN1ig3_45mIyaZ5BxWXIaMMeta } from "/opt/buildhome/repo/pages/stores/create/[type]/voucher-codes.vue?macro=true";
import { default as indexC9wUr3_IEUYMGLU8PoDh1sULFmkchHNX61WIcZ2GQeoMeta } from "/opt/buildhome/repo/pages/stores/[salesChannelId]/emails/index.vue?macro=true";
import { default as _91page_93jyKfwprH7UQ07a2IVaLpILNduTZMYc_45K25c1XSeFs3MMeta } from "/opt/buildhome/repo/pages/stores/[salesChannelId]/emails/[page].vue?macro=true";
import { default as voucher_45codesIobD57f1vFtulVDKD7bzG_OEZtnYokwElMykgaGRSK4Meta } from "/opt/buildhome/repo/pages/stores/[salesChannelId]/voucher-codes.vue?macro=true";
import { default as indexTzIqX8Micn0kc_ThliCqU4XXE_BPcYiEdbu4nAv5EScMeta } from "/opt/buildhome/repo/pages/stores/create/[type]/fulfilment/index.vue?macro=true";
import { default as _91page_93r3_45QKoB6cD6x53supRts93PCBLAtUxU4LFKrwoop_W4Meta } from "/opt/buildhome/repo/pages/stores/create/[type]/fulfilment/[page].vue?macro=true";
import { default as indexLbK94LMaEP2SxzUCzppEaOR0pJo_458QEakOv1kVFa20QMeta } from "/opt/buildhome/repo/pages/stores/[salesChannelId]/fulfilment/index.vue?macro=true";
import { default as _91page_93rrFvW88T78BDbkGHthqtwjbSQEfp5cUP7J9aSja49OsMeta } from "/opt/buildhome/repo/pages/stores/[salesChannelId]/fulfilment/[page].vue?macro=true";
import { default as delivery_45informationhHLKADQrQ9ngDRChC_9msJ1WD_qLcqORU2QlFZ_45iDIUMeta } from "/opt/buildhome/repo/pages/stores/create/[type]/delivery-information.vue?macro=true";
import { default as third_45party_45tracking3X9aWWp6Z8ugnimT9jsAdkEBH4_ugQ2iZ9yZpgg8aCEMeta } from "/opt/buildhome/repo/pages/stores/create/[type]/third-party-tracking.vue?macro=true";
import { default as delivery_45informationF7rNTbT_8eWLwZFMaQYRW_6NdQnAmxxIXtlAKV_x2N0Meta } from "/opt/buildhome/repo/pages/stores/[salesChannelId]/delivery-information.vue?macro=true";
import { default as third_45party_45trackingt3FNVvaF0T4Xi_45qw3PiABI5b2BhQ5xT7zWbBL7PvJCcMeta } from "/opt/buildhome/repo/pages/stores/[salesChannelId]/third-party-tracking.vue?macro=true";
import { default as storeso_451e3vTPsxisExuQ7SiyFzVx3ZTuyaE69garCT7VSQQMeta } from "/opt/buildhome/repo/pages/stores.vue?macro=true";
import { default as indexKZjE2rM2M1rsH3vTc7ZiGWXpDAxku9brNErhRdQQgd8Meta } from "/opt/buildhome/repo/pages/reports/index.vue?macro=true";
import { default as reportsGYz6wCm261C6PSoxw3RiAIEj_458tVEJlC_45ZKGVtOFGTsMeta } from "/opt/buildhome/repo/pages/reports.vue?macro=true";
import { default as index3xxHt9bk0QerByJNXPrS9ijmaorPYpVbp15BcHdsQBcMeta } from "/opt/buildhome/repo/pages/products/index.vue?macro=true";
import { default as _91type_93tRo9qbkmECt0UEfqq1JhnFFQmuc5DBLrafoe4vW_45mPgMeta } from "/opt/buildhome/repo/pages/products/create/[type].vue?macro=true";
import { default as indexbEpmL4rC9lK3m9sgQzDzn_45f3XfIIpFTbnyfZTXwwwOIMeta } from "/opt/buildhome/repo/pages/products/[productId]/index.vue?macro=true";
import { default as createHSiaXA4S2_ccIk_BUtILicKm4Rx_MeRG6gXMzZmkiTMMeta } from "/opt/buildhome/repo/pages/products/create/variants/create.vue?macro=true";
import { default as createqcBzwkSpA62o_tdfmW3Rb8y6ZNVLRVMIu48V1JCYmuAMeta } from "/opt/buildhome/repo/pages/products/[productId]/variants/create.vue?macro=true";
import { default as _91variantId_93CU4Fh1xw5QG875DxdbRzGOnoD_hbqbuHXpyLXP1sgKwMeta } from "/opt/buildhome/repo/pages/products/[productId]/variants/[variantId].vue?macro=true";
import { default as productsY2XB_454cDKLta72k90vx8ISbqhUFoUiYZTBg44pjiRE4Meta } from "/opt/buildhome/repo/pages/products.vue?macro=true";
import { default as index__45UT5R7yDr88Ya1Y9OwbNw0zV1F7_45gC0NkPqjZf_6qsMeta } from "/opt/buildhome/repo/pages/settings/index.vue?macro=true";
import { default as indexRfvRcwC4r8y6YKVuaY8WIpW2Lmjz2bNyhoJZxIC_45_45dgMeta } from "/opt/buildhome/repo/pages/settings/users/index.vue?macro=true";
import { default as _91userId_93I3gMIwX0DHMXQib_45tdZIECSo0_P3DgQ7YowgmVyQeWcMeta } from "/opt/buildhome/repo/pages/settings/users/[userId].vue?macro=true";
import { default as email6mwFdmyGVzbd7MOan0nEc5IdtsRqMJ2_r2jGVminVcgMeta } from "/opt/buildhome/repo/pages/settings/users/create/email.vue?macro=true";
import { default as usernamec6t42W6FlCwejrVk5Q2Uc8lk2f1UR10LRgpbvN8D9iEMeta } from "/opt/buildhome/repo/pages/settings/users/create/username.vue?macro=true";
import { default as indexOL4OTNJ4zWJAzeRdloBlteXNzNz7yCSPfBnsXl4jAUoMeta } from "/opt/buildhome/repo/pages/settings/users/invitations/index.vue?macro=true";
import { default as _91invitationId_93uqG_45KPcSZEh2TbdyJCU45KWnBG_6kyBMSB6Fu2GdG00Meta } from "/opt/buildhome/repo/pages/settings/users/invitations/[invitationId].vue?macro=true";
import { default as users98tMRRQGN2fO6r84ue9SZaDjaM_45K1txyxsBkfqOXTDgMeta } from "/opt/buildhome/repo/pages/settings/users.vue?macro=true";
import { default as billingopbqOjpQWG3zErPEhz52Hq9tfAiQVhF4mq_LAVMn2RcMeta } from "/opt/buildhome/repo/pages/settings/billing.vue?macro=true";
import { default as generalIY2MuoL7BN7ePZ7jYphlPo7weN_453_45sQcDqupHq_pSlwMeta } from "/opt/buildhome/repo/pages/settings/general.vue?macro=true";
import { default as index6_45dGcP76HNOy9KB0jJVqOQ8mRRmgAcjI_45sl_IDYmiRoMeta } from "/opt/buildhome/repo/pages/settings/imports/index.vue?macro=true";
import { default as mappingc_45zAXrx6EH_45ZVYdbZtK6z9jKxEbc1ue7bCTjLt3RrfQMeta } from "/opt/buildhome/repo/pages/settings/imports/mapping.vue?macro=true";
import { default as importsFwpOEdwOq1nr798JAWLktw2btCZREVxvuwpKHpj_5F8Meta } from "/opt/buildhome/repo/pages/settings/imports.vue?macro=true";
import { default as indexg5Y9ENJWf8OaP69ulxZrCQnnUl7k9Ql7TyIhhXI1BPoMeta } from "/opt/buildhome/repo/pages/settings/api-tokens/index.vue?macro=true";
import { default as createziJrmald5K_V7vtxjkhh1YFf3sZWqf5iDooV61R36vwMeta } from "/opt/buildhome/repo/pages/settings/api-tokens/create.vue?macro=true";
import { default as api_45tokensZsCqyCMBDyjU2UqezamWQ4mMIfSgy6_7A_451d2j0TOt8Meta } from "/opt/buildhome/repo/pages/settings/api-tokens.vue?macro=true";
import { default as indexkumoZ4XJitPP6wICIDdkTV66dMQGxWY5hglKIB28QU8Meta } from "/opt/buildhome/repo/pages/settings/cost-centres/index.vue?macro=true";
import { default as createpuKG7Pw8oK8t_45IiVsorx2ZP01w3o_XLqYpH_j_45FfgrcMeta } from "/opt/buildhome/repo/pages/settings/cost-centres/create.vue?macro=true";
import { default as _91costCentreId_93qpsF08VcuQhK8_454ah4uCtnp7L8UNhE4cVW2gs12fWSUMeta } from "/opt/buildhome/repo/pages/settings/cost-centres/[costCentreId].vue?macro=true";
import { default as cost_45centresd6BT8o2DfaW9255r_45uzct7ReFmLxY4mkkTZrYhi6V7cMeta } from "/opt/buildhome/repo/pages/settings/cost-centres.vue?macro=true";
import { default as indexxghUhE9SdtxBh9Y10uVL2fpF_45y10tZFEYYq4omKHBRgMeta } from "/opt/buildhome/repo/pages/settings/email-domains/index.vue?macro=true";
import { default as _91hostname_93J1BcQAaL3NJaz3VTaoXLD9HeY3_0UMt1tfXOHJL3VeAMeta } from "/opt/buildhome/repo/pages/settings/email-domains/[hostname].vue?macro=true";
import { default as email_45domains_45SESWaCQWtSRhlw6AhdjQY_45pzx_HmTzQYLfyxFrDWs0Meta } from "/opt/buildhome/repo/pages/settings/email-domains.vue?macro=true";
import { default as indexHdUyeWiczHxb_XqNZc_455GpII2Z0EBg1kLEqelX8aLMcMeta } from "/opt/buildhome/repo/pages/settings/store-switchers/index.vue?macro=true";
import { default as _91uuid_939WFXGTkhFNaV5lV8rdXA4Y2xAK9gPfSI5OW1yYEN1ykMeta } from "/opt/buildhome/repo/pages/settings/store-switchers/[uuid].vue?macro=true";
import { default as create6C1QoXrMvxa_453lheIkrsM51zKqRtFgPKGyH7vrT7d6YMeta } from "/opt/buildhome/repo/pages/settings/store-switchers/create.vue?macro=true";
import { default as store_45switchersmdRJg2_cPeJlnmra3NYV0V43uegw8dP8Ie_45YNWoisUEMeta } from "/opt/buildhome/repo/pages/settings/store-switchers.vue?macro=true";
import { default as indexserT_4HJufFvnDhfbsr71GQXLiq7lgUltOMAZ_BVGB4Meta } from "/opt/buildhome/repo/pages/settings/redeem-locations/index.vue?macro=true";
import { default as createyWXoskKnJcoel2i5ECBr3vw6rFWAuzE35B3zMKXt_wMMeta } from "/opt/buildhome/repo/pages/settings/redeem-locations/create.vue?macro=true";
import { default as _91redeemLocationId_93GDB4x7v4H_45bhWroLURwyPuHvBa_45KNjPOuB_45C3E2jcAcMeta } from "/opt/buildhome/repo/pages/settings/redeem-locations/[redeemLocationId].vue?macro=true";
import { default as redeem_45locationsBSa_mr_45dv8G41ovlH3o2KwtvMgr_45h_bykrIMSpOaH8oMeta } from "/opt/buildhome/repo/pages/settings/redeem-locations.vue?macro=true";
import { default as indexYpwcEPMDT2rflTE5P7LnehGupvTvkQ4FpuEmfvRaaIcMeta } from "/opt/buildhome/repo/pages/settings/bulk-vouchers/index.vue?macro=true";
import { default as mappingn_452vrs1V_45Z5CFcdZ6WJ6_Zm1aUNTk0Pggrdo3MdSJkQMeta } from "/opt/buildhome/repo/pages/settings/bulk-vouchers/mapping.vue?macro=true";
import { default as index_45VPCLqj3O4QTgGz1CN4fE2EK6cNTxPHtENU5KRp7lB0Meta } from "/opt/buildhome/repo/pages/settings/payment-gateways/index.vue?macro=true";
import { default as indexMSwINxf1DBBWr3z3OqXlxcYVlUaRL31FwI2jVle_IoQMeta } from "/opt/buildhome/repo/pages/settings/voucher-reference-pools/index.vue?macro=true";
import { default as segmentybsMdvgUH_7pkZTQkyEt4D_4Z25XB3S9ZIqu_3SLLQwMeta } from "/opt/buildhome/repo/pages/settings/voucher-reference-pools/segment.vue?macro=true";
import { default as voucher_45reference_45poolsHeeZAIxE3_GosHYIyGo1614_452YfBNOn8pEfh8VnM2AUMeta } from "/opt/buildhome/repo/pages/settings/voucher-reference-pools.vue?macro=true";
import { default as _91gatewayId_93Aqaa3pbaRvCY3RHwsfI63AZTRmODen4RvUTFczFPNVMMeta } from "/opt/buildhome/repo/pages/settings/payment-gateways/[gatewayId].vue?macro=true";
import { default as paypalQYSR0LkSi3Tyg5C041HkBnaVf6IOdZJzKW_dngCqwwAMeta } from "/opt/buildhome/repo/pages/settings/payment-gateways/connect/paypal.vue?macro=true";
import { default as stripenXeU0ijY0j2kDP52v6CPR1f7Z0TX_45flu3inkXjWxfsIMeta } from "/opt/buildhome/repo/pages/settings/payment-gateways/connect/stripe.vue?macro=true";
import { default as fanbasisYDWHTf4CIh_lA2juuP_96Tb5A_45Gn5U7EHZynz05vlMMMeta } from "/opt/buildhome/repo/pages/settings/payment-gateways/connect/fanbasis.vue?macro=true";
import { default as settingsXxHd4Gbotd8GwcMHWDBbPo2R_452rFtc31BzCyJeZgaf0Meta } from "/opt/buildhome/repo/pages/settings.vue?macro=true";
import { default as index3MLxj9TyGtxvLhNM7ZYOj8vzwMMFIpv_45PtkRVDZF27IMeta } from "/opt/buildhome/repo/pages/categories/index.vue?macro=true";
import { default as _91categoryId_93XyVUMujjmRmBw_45XemoCG1am7vW_45HDAmqYuTVrH_nsUAMeta } from "/opt/buildhome/repo/pages/categories/[categoryId].vue?macro=true";
import { default as _91salesChannelId_93MLylOQ59Nknj_45wVv8p8UfLDVc4o1ZqyrdEXZjCQvu_sMeta } from "/opt/buildhome/repo/pages/categories/create/[salesChannelId].vue?macro=true";
import { default as categoriesf4hrQQ3_45PAWdq8HAnXiGms9GEF9CRBVt8oafowiCkKUMeta } from "/opt/buildhome/repo/pages/categories.vue?macro=true";
import { default as indexpyK1Qv8FxRspYCQzEzRnvMreuiJUzc44SW0VMZfPow4Meta } from "/opt/buildhome/repo/pages/fulfilment/index.vue?macro=true";
import { default as fulfilledOn3lC1m0rhr4nHwsebkG4oEAxVjcWg9O3e_45Pe2k3FygMeta } from "/opt/buildhome/repo/pages/fulfilment/fulfilled.vue?macro=true";
import { default as fulfilmentyY0PrviRLZm0RVETs1JRNPwQlAbf1wc5LOEybjyKjhAMeta } from "/opt/buildhome/repo/pages/fulfilment.vue?macro=true";
import { default as logoutgU_G4QHH66XaZEr3gUo0k9EyXTJMADGobsXma60gyPwMeta } from "/opt/buildhome/repo/pages/auth/logout.vue?macro=true";
import { default as index8RMBEEiZ8c2LxNHpORZzZm6NGpMInFxj3NPGw3e8UM0Meta } from "/opt/buildhome/repo/pages/enhancements/index.vue?macro=true";
import { default as create5I4aqaasK8gLr6u7PA9kEkStPqREqTr4_450dBbap1qB0Meta } from "/opt/buildhome/repo/pages/enhancements/create.vue?macro=true";
import { default as _91enhancementId_93tIoD_dKGwKftnx82q5wIUO0qgGTAXZcv7rCGM1D4Bh4Meta } from "/opt/buildhome/repo/pages/enhancements/[enhancementId].vue?macro=true";
import { default as enhancementsy3JkNFUsNetBOJhqroMKA3_45wZtMlJl9uT4XU7w2z3t0Meta } from "/opt/buildhome/repo/pages/enhancements.vue?macro=true";
import { default as settingszwZz_45BkI2zK2jga9EVHIt3VnA9vFMqqUsRmYDu3RuMMMeta } from "/opt/buildhome/repo/pages/auth/settings.vue?macro=true";
import { default as indexxhzzdcekkV2vdGCZGBiksWyj_45f0r2hBVVHMfPs0KJ0sMeta } from "/opt/buildhome/repo/pages/terminal/index.vue?macro=true";
import { default as indexWMMZn446i9PPWx2Qv46U9e7qJpqSuJ6vwmesciQ6nl8Meta } from "/opt/buildhome/repo/pages/analytics/index.vue?macro=true";
import { default as indexAn22Dq4tLMvvR95t9CjWbAGe473_45T5KWtiB62HCYMMEMeta } from "/opt/buildhome/repo/pages/discounts/index.vue?macro=true";
import { default as indexFICVtqk7yTzTpWZ9NuaoKj_45X5r8ObsEsnjQKwEXgNQcMeta } from "/opt/buildhome/repo/pages/auth/login/index.vue?macro=true";
import { default as account_45suspended3p2CBC_myjWXsRbi1UtIaZq8cTAfN1a4ymvqknmyVQ4Meta } from "/opt/buildhome/repo/pages/account-suspended.vue?macro=true";
import { default as invalidR_XGWEK8yP4DEpAmC0GHy8KQ_xvMWeHzdKZX_XisacUMeta } from "/opt/buildhome/repo/pages/invitation/invalid.vue?macro=true";
import { default as reset_45passwordVxuQyUMBySjF4TTBevFLXice7Yi56zw2bZYHEWNi0ewMeta } from "/opt/buildhome/repo/pages/auth/reset-password.vue?macro=true";
import { default as index9Z9_45V9s1EiOLkL5nx428_45Yg4U3yU3hBEHAD_451R3E_tkMeta } from "/opt/buildhome/repo/pages/terminal/redeem/index.vue?macro=true";
import { default as settings3ruN122aMjM2tQQLGYtxOIV0DGHVT1_McqZgUufdyMIMeta } from "/opt/buildhome/repo/pages/terminal/auth/settings.vue?macro=true";
import { default as _91type_93UeVx9NI_45K11Zy_45p93nDcufsG_45aXbrm2wrOqhW3p6BKsMeta } from "/opt/buildhome/repo/pages/discounts/create/[type].vue?macro=true";
import { default as account_45pending_45deletion8Zst1epIj38Kwek62ziPtM5USZY6JKOCG4DzY1v_45z_458Meta } from "/opt/buildhome/repo/pages/account-pending-deletion.vue?macro=true";
import { default as _91accountSlug_93_Le5FU5Cgu3HfMMCXaPDogIzbFyf8pfsTWKvWyZmjrgMeta } from "/opt/buildhome/repo/pages/auth/login/[accountSlug].vue?macro=true";
import { default as _91invitationId_93CrEifKNOZrAcSU3nGIq2jTRLhfx7S_45il9Nu_45EWemX_45sMeta } from "/opt/buildhome/repo/pages/invitation/[invitationId].vue?macro=true";
import { default as indexOY9o14SKSkh07H3CJ28fhD8MuhQUZBL7iMAMAJi5iycMeta } from "/opt/buildhome/repo/pages/terminal/sell/[type]/index.vue?macro=true";
import { default as request_45password_45resetfigfZvR7VeojASce_45Ys8Btzmmtu08uu3lYTno84L_KAMeta } from "/opt/buildhome/repo/pages/auth/request-password-reset.vue?macro=true";
import { default as _91reference_93D2b1DwMWbZh_3tVgp_PyzC7loxiIIob7NzwBCyVkItkMeta } from "/opt/buildhome/repo/pages/terminal/redeem/[reference].vue?macro=true";
import { default as codesstun1DJej084TDhHx6IiFvwa6FC73ZZ77vFFvYcedHcMeta } from "/opt/buildhome/repo/pages/discounts/[discountId]/codes.vue?macro=true";
import { default as indexhJK7RtNRR8HiyFt8G80zDUFqLjVLC77KMn6qaolZ7TgMeta } from "/opt/buildhome/repo/pages/discounts/[discountId]/index.vue?macro=true";
import { default as confirmationCAJCu9Xzv1x1Ye7CZ9jDt7gPs5t7Ydvc36rRq0_45c1mIMeta } from "/opt/buildhome/repo/pages/terminal/redeem/confirmation.vue?macro=true";
import { default as reset_45password_45confirmationmB0S9Xxc6CHT70hun40wNnIVpDqZsV8iCQpMJ86TRkkMeta } from "/opt/buildhome/repo/pages/auth/reset-password-confirmation.vue?macro=true";
import { default as invalid_45password_45reset_45token_Bx3svjDUdDQxzg6jYttwAC9YRam9Po2yq4t0jEprfgMeta } from "/opt/buildhome/repo/pages/auth/invalid-password-reset-token.vue?macro=true";
import { default as _91hash_93ZVvT3jaz6QENTiWf9GP3G6Tb_45b2bzXAoxur9SyNQgh0Meta } from "/opt/buildhome/repo/pages/auth/verify-email/[userId]/[hash].vue?macro=true";
import { default as createQcuoGMgwr6zIhUJXkLu_Ax6SacOw4qz0B05mwGPPXQ0Meta } from "/opt/buildhome/repo/pages/discounts/[discountId]/group/create.vue?macro=true";
import { default as request_45password_45reset_45confirmationgXimSDB_5APWWvCxBDHAMdlglFjyNhUlHT17SXgYFu8Meta } from "/opt/buildhome/repo/pages/auth/request-password-reset-confirmation.vue?macro=true";
import { default as _91groupIndex_933linrfrGKZcZ1SwpChiZK7gU_MGhm_yMhXqnqr5mo3QMeta } from "/opt/buildhome/repo/pages/discounts/[discountId]/group/[groupIndex].vue?macro=true";
import { default as createUKFOXUzDfGhxkVDPUdxi0wRgrZGa45MLFWvRZPkvyOEMeta } from "/opt/buildhome/repo/pages/discounts/create/per-product/group/create.vue?macro=true";
import { default as indexMLtuoyX9m5JX1L5Ouu7du6TmhUnmg8WrnSLerY6_JGAMeta } from "/opt/buildhome/repo/pages/terminal/redeem/voucher/[reference]/index.vue?macro=true";
import { default as indexWiAbGBsGnWf4wb2_59yUSopdu0NgKW1I7w1p30jkt_450Meta } from "/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/index.vue?macro=true";
import { default as summaryl881OFx1HHLZRCW_qAH8wevfjR6pRLL_45BWA5qJWB5moMeta } from "/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/summary.vue?macro=true";
import { default as waitingxX9ANmriKJm2QY3ytLhUv3YQgkyMBfCut_pRRgr7sugMeta } from "/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/waiting.vue?macro=true";
import { default as complete5w0ES87g8fc6PCjPlO2CQCinUluPwc599oPMwzWDGPsMeta } from "/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/complete.vue?macro=true";
import { default as _91redeemableId_93UoMlN2NFkQLcQC05c0t3UvKDw7_45So8AYyTtl8kuG2nsMeta } from "/opt/buildhome/repo/pages/terminal/redeem/voucher/[reference]/[redeemableId].vue?macro=true";
import { default as postGnRtZQ6WGhRtKae_OM8VWceSKfDdByzeHjY_45pFrUgnUMeta } from "/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/delivery/post.vue?macro=true";
import { default as emailsz64xoZ0OTa7_FKxzvMsRcrjJXZfzRJigkIm0fmjEQYMeta } from "/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/delivery/email.vue?macro=true";
import { default as indexIv5knIZ6SZP8ced8wMtFj7Aw_45S_45jfvgKaIdPFO_Vd2kMeta } from "/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/delivery/index.vue?macro=true";
import { default as collectUWtuN1JbjUFpE7k_UEkxVZO_NaLfQntB9VQyE65J4g8Meta } from "/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/delivery/collect.vue?macro=true";
import { default as index_45DRsGb9TcKrX4BNf5JnNZpbVi9KAsV3BYb9GxjbkKIsMeta } from "/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/index.vue?macro=true";
import { default as variantr_45ZhEbxr_45Cv8y9U1bTrwA8SYFItj34bK1eEqlG_KDqgMeta } from "/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/variant.vue?macro=true";
import { default as monetaryo5q7xh7xfsgo9Uk9jvDw7_ZYAm8lQhVtUBfQaptJ38wMeta } from "/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/monetary.vue?macro=true";
import { default as enhancementsyEerPp4yxlU_45qXcqTjdT7AH_jO7XYjfrNYIaSahdZ9IMeta } from "/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/enhancements.vue?macro=true";
import { default as product_45info7EZDKzeE6ZB_45YqdE0adPQgEi5TJGcztFmOM9OdRrd70Meta } from "/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/product-info.vue?macro=true";
import { default as personalisationTHGV8FmE1NbgubKyBMLRjTQo46MJkFWyiltvKP_f7xUMeta } from "/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/personalisation.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: ordersbykzvWgceilKkMpFXAx0hhlDa7s_45ZHIPIATLTDuLIt8Meta?.name,
    path: "/orders",
    component: () => import("/opt/buildhome/repo/pages/orders.vue"),
    children: [
  {
    name: "orders",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/orders/index.vue")
  },
  {
    name: "orders-orderId",
    path: ":orderId()",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/index.vue")
  },
  {
    name: "orders-orderId-page",
    path: ":orderId()/:page()",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/[page].vue")
  },
  {
    name: "orders-orderId-vouchers-voucherId",
    path: ":orderId()/vouchers/:voucherId()",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/vouchers/[voucherId]/index.vue")
  },
  {
    name: "orders-orderId-vouchers-voucherId-page",
    path: ":orderId()/vouchers/:voucherId()/:page()",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/vouchers/[voucherId]/[page].vue")
  }
]
  },
  {
    name: storeso_451e3vTPsxisExuQ7SiyFzVx3ZTuyaE69garCT7VSQQMeta?.name,
    path: "/stores",
    component: () => import("/opt/buildhome/repo/pages/stores.vue"),
    children: [
  {
    name: "stores",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/stores/index.vue")
  },
  {
    name: "stores-interstitial",
    path: "interstitial",
    component: () => import("/opt/buildhome/repo/pages/stores/interstitial.vue")
  },
  {
    name: "stores-create-type-faq",
    path: "create/:type()/faq",
    component: () => import("/opt/buildhome/repo/pages/stores/create/[type]/faq.vue")
  },
  {
    name: "stores-create-type",
    path: "create/:type()",
    component: () => import("/opt/buildhome/repo/pages/stores/create/[type]/index.vue")
  },
  {
    name: "stores-create-type-terms",
    path: "create/:type()/terms",
    component: () => import("/opt/buildhome/repo/pages/stores/create/[type]/terms.vue")
  },
  {
    name: "stores-salesChannelId-faq",
    path: ":salesChannelId()/faq",
    component: () => import("/opt/buildhome/repo/pages/stores/[salesChannelId]/faq.vue")
  },
  {
    name: "stores-create-type-design",
    path: "create/:type()/design",
    component: () => import("/opt/buildhome/repo/pages/stores/create/[type]/design.vue")
  },
  {
    name: "stores-create-type-privacy",
    path: "create/:type()/privacy",
    component: () => import("/opt/buildhome/repo/pages/stores/create/[type]/privacy.vue")
  },
  {
    name: "stores-salesChannelId",
    path: ":salesChannelId()",
    component: () => import("/opt/buildhome/repo/pages/stores/[salesChannelId]/index.vue")
  },
  {
    name: "stores-salesChannelId-terms",
    path: ":salesChannelId()/terms",
    component: () => import("/opt/buildhome/repo/pages/stores/[salesChannelId]/terms.vue")
  },
  {
    name: "stores-salesChannelId-design",
    path: ":salesChannelId()/design",
    component: () => import("/opt/buildhome/repo/pages/stores/[salesChannelId]/design.vue")
  },
  {
    name: "stores-salesChannelId-privacy",
    path: ":salesChannelId()/privacy",
    component: () => import("/opt/buildhome/repo/pages/stores/[salesChannelId]/privacy.vue")
  },
  {
    name: "stores-create-type-emails",
    path: "create/:type()/emails",
    component: () => import("/opt/buildhome/repo/pages/stores/create/[type]/emails/index.vue")
  },
  {
    name: "stores-create-type-emails-page",
    path: "create/:type()/emails/:page()",
    component: () => import("/opt/buildhome/repo/pages/stores/create/[type]/emails/[page].vue")
  },
  {
    name: "stores-create-type-voucher-codes",
    path: "create/:type()/voucher-codes",
    component: () => import("/opt/buildhome/repo/pages/stores/create/[type]/voucher-codes.vue")
  },
  {
    name: "stores-salesChannelId-emails",
    path: ":salesChannelId()/emails",
    component: () => import("/opt/buildhome/repo/pages/stores/[salesChannelId]/emails/index.vue")
  },
  {
    name: "stores-salesChannelId-emails-page",
    path: ":salesChannelId()/emails/:page()",
    component: () => import("/opt/buildhome/repo/pages/stores/[salesChannelId]/emails/[page].vue")
  },
  {
    name: "stores-salesChannelId-voucher-codes",
    path: ":salesChannelId()/voucher-codes",
    component: () => import("/opt/buildhome/repo/pages/stores/[salesChannelId]/voucher-codes.vue")
  },
  {
    name: "stores-create-type-fulfilment",
    path: "create/:type()/fulfilment",
    component: () => import("/opt/buildhome/repo/pages/stores/create/[type]/fulfilment/index.vue")
  },
  {
    name: "stores-create-type-fulfilment-page",
    path: "create/:type()/fulfilment/:page()",
    component: () => import("/opt/buildhome/repo/pages/stores/create/[type]/fulfilment/[page].vue")
  },
  {
    name: "stores-salesChannelId-fulfilment",
    path: ":salesChannelId()/fulfilment",
    component: () => import("/opt/buildhome/repo/pages/stores/[salesChannelId]/fulfilment/index.vue")
  },
  {
    name: "stores-salesChannelId-fulfilment-page",
    path: ":salesChannelId()/fulfilment/:page()",
    component: () => import("/opt/buildhome/repo/pages/stores/[salesChannelId]/fulfilment/[page].vue")
  },
  {
    name: "stores-create-type-delivery-information",
    path: "create/:type()/delivery-information",
    component: () => import("/opt/buildhome/repo/pages/stores/create/[type]/delivery-information.vue")
  },
  {
    name: "stores-create-type-third-party-tracking",
    path: "create/:type()/third-party-tracking",
    component: () => import("/opt/buildhome/repo/pages/stores/create/[type]/third-party-tracking.vue")
  },
  {
    name: "stores-salesChannelId-delivery-information",
    path: ":salesChannelId()/delivery-information",
    component: () => import("/opt/buildhome/repo/pages/stores/[salesChannelId]/delivery-information.vue")
  },
  {
    name: "stores-salesChannelId-third-party-tracking",
    path: ":salesChannelId()/third-party-tracking",
    component: () => import("/opt/buildhome/repo/pages/stores/[salesChannelId]/third-party-tracking.vue")
  }
]
  },
  {
    name: reportsGYz6wCm261C6PSoxw3RiAIEj_458tVEJlC_45ZKGVtOFGTsMeta?.name,
    path: "/reports",
    component: () => import("/opt/buildhome/repo/pages/reports.vue"),
    children: [
  {
    name: "reports",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/reports/index.vue")
  }
]
  },
  {
    name: productsY2XB_454cDKLta72k90vx8ISbqhUFoUiYZTBg44pjiRE4Meta?.name,
    path: "/products",
    component: () => import("/opt/buildhome/repo/pages/products.vue"),
    children: [
  {
    name: "products",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/products/index.vue")
  },
  {
    name: "products-create-type",
    path: "create/:type()",
    component: () => import("/opt/buildhome/repo/pages/products/create/[type].vue")
  },
  {
    name: "products-productId",
    path: ":productId()",
    component: () => import("/opt/buildhome/repo/pages/products/[productId]/index.vue")
  },
  {
    name: "products-create-variants-create",
    path: "create/variants/create",
    component: () => import("/opt/buildhome/repo/pages/products/create/variants/create.vue")
  },
  {
    name: "products-productId-variants-create",
    path: ":productId()/variants/create",
    component: () => import("/opt/buildhome/repo/pages/products/[productId]/variants/create.vue")
  },
  {
    name: "products-productId-variants-variantId",
    path: ":productId()/variants/:variantId()",
    component: () => import("/opt/buildhome/repo/pages/products/[productId]/variants/[variantId].vue")
  }
]
  },
  {
    name: settingsXxHd4Gbotd8GwcMHWDBbPo2R_452rFtc31BzCyJeZgaf0Meta?.name,
    path: "/settings",
    component: () => import("/opt/buildhome/repo/pages/settings.vue"),
    children: [
  {
    name: "settings",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/settings/index.vue")
  },
  {
    name: users98tMRRQGN2fO6r84ue9SZaDjaM_45K1txyxsBkfqOXTDgMeta?.name,
    path: "users",
    component: () => import("/opt/buildhome/repo/pages/settings/users.vue"),
    children: [
  {
    name: "settings-users",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/settings/users/index.vue")
  },
  {
    name: "settings-users-userId",
    path: ":userId()",
    component: () => import("/opt/buildhome/repo/pages/settings/users/[userId].vue")
  },
  {
    name: "settings-users-create-email",
    path: "create/email",
    component: () => import("/opt/buildhome/repo/pages/settings/users/create/email.vue")
  },
  {
    name: "settings-users-create-username",
    path: "create/username",
    component: () => import("/opt/buildhome/repo/pages/settings/users/create/username.vue")
  },
  {
    name: "settings-users-invitations",
    path: "invitations",
    component: () => import("/opt/buildhome/repo/pages/settings/users/invitations/index.vue")
  },
  {
    name: "settings-users-invitations-invitationId",
    path: "invitations/:invitationId()",
    component: () => import("/opt/buildhome/repo/pages/settings/users/invitations/[invitationId].vue")
  }
]
  },
  {
    name: "settings-billing",
    path: "billing",
    component: () => import("/opt/buildhome/repo/pages/settings/billing.vue")
  },
  {
    name: "settings-general",
    path: "general",
    component: () => import("/opt/buildhome/repo/pages/settings/general.vue")
  },
  {
    name: importsFwpOEdwOq1nr798JAWLktw2btCZREVxvuwpKHpj_5F8Meta?.name,
    path: "imports",
    component: () => import("/opt/buildhome/repo/pages/settings/imports.vue"),
    children: [
  {
    name: "settings-imports",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/settings/imports/index.vue")
  },
  {
    name: "settings-imports-mapping",
    path: "mapping",
    component: () => import("/opt/buildhome/repo/pages/settings/imports/mapping.vue")
  }
]
  },
  {
    name: api_45tokensZsCqyCMBDyjU2UqezamWQ4mMIfSgy6_7A_451d2j0TOt8Meta?.name,
    path: "api-tokens",
    component: () => import("/opt/buildhome/repo/pages/settings/api-tokens.vue"),
    children: [
  {
    name: "settings-api-tokens",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/settings/api-tokens/index.vue")
  },
  {
    name: "settings-api-tokens-create",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/settings/api-tokens/create.vue")
  }
]
  },
  {
    name: cost_45centresd6BT8o2DfaW9255r_45uzct7ReFmLxY4mkkTZrYhi6V7cMeta?.name,
    path: "cost-centres",
    component: () => import("/opt/buildhome/repo/pages/settings/cost-centres.vue"),
    children: [
  {
    name: "settings-cost-centres",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/settings/cost-centres/index.vue")
  },
  {
    name: "settings-cost-centres-create",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/settings/cost-centres/create.vue")
  },
  {
    name: "settings-cost-centres-costCentreId",
    path: ":costCentreId()",
    component: () => import("/opt/buildhome/repo/pages/settings/cost-centres/[costCentreId].vue")
  }
]
  },
  {
    name: email_45domains_45SESWaCQWtSRhlw6AhdjQY_45pzx_HmTzQYLfyxFrDWs0Meta?.name,
    path: "email-domains",
    component: () => import("/opt/buildhome/repo/pages/settings/email-domains.vue"),
    children: [
  {
    name: "settings-email-domains",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/settings/email-domains/index.vue")
  },
  {
    name: "settings-email-domains-hostname",
    path: ":hostname()",
    component: () => import("/opt/buildhome/repo/pages/settings/email-domains/[hostname].vue")
  }
]
  },
  {
    name: store_45switchersmdRJg2_cPeJlnmra3NYV0V43uegw8dP8Ie_45YNWoisUEMeta?.name,
    path: "store-switchers",
    component: () => import("/opt/buildhome/repo/pages/settings/store-switchers.vue"),
    children: [
  {
    name: "settings-store-switchers",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/settings/store-switchers/index.vue")
  },
  {
    name: "settings-store-switchers-uuid",
    path: ":uuid()",
    component: () => import("/opt/buildhome/repo/pages/settings/store-switchers/[uuid].vue")
  },
  {
    name: "settings-store-switchers-create",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/settings/store-switchers/create.vue")
  }
]
  },
  {
    name: redeem_45locationsBSa_mr_45dv8G41ovlH3o2KwtvMgr_45h_bykrIMSpOaH8oMeta?.name,
    path: "redeem-locations",
    component: () => import("/opt/buildhome/repo/pages/settings/redeem-locations.vue"),
    children: [
  {
    name: "settings-redeem-locations",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/settings/redeem-locations/index.vue")
  },
  {
    name: "settings-redeem-locations-create",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/settings/redeem-locations/create.vue")
  },
  {
    name: "settings-redeem-locations-redeemLocationId",
    path: ":redeemLocationId()",
    component: () => import("/opt/buildhome/repo/pages/settings/redeem-locations/[redeemLocationId].vue")
  }
]
  },
  {
    name: "settings-bulk-vouchers",
    path: "bulk-vouchers",
    component: () => import("/opt/buildhome/repo/pages/settings/bulk-vouchers/index.vue")
  },
  {
    name: "settings-bulk-vouchers-mapping",
    path: "bulk-vouchers/mapping",
    component: () => import("/opt/buildhome/repo/pages/settings/bulk-vouchers/mapping.vue")
  },
  {
    name: "settings-payment-gateways",
    path: "payment-gateways",
    component: () => import("/opt/buildhome/repo/pages/settings/payment-gateways/index.vue")
  },
  {
    name: voucher_45reference_45poolsHeeZAIxE3_GosHYIyGo1614_452YfBNOn8pEfh8VnM2AUMeta?.name,
    path: "voucher-reference-pools",
    component: () => import("/opt/buildhome/repo/pages/settings/voucher-reference-pools.vue"),
    children: [
  {
    name: "settings-voucher-reference-pools",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/settings/voucher-reference-pools/index.vue")
  },
  {
    name: "settings-voucher-reference-pools-segment",
    path: "segment",
    component: () => import("/opt/buildhome/repo/pages/settings/voucher-reference-pools/segment.vue")
  }
]
  },
  {
    name: "settings-payment-gateways-gatewayId",
    path: "payment-gateways/:gatewayId()",
    component: () => import("/opt/buildhome/repo/pages/settings/payment-gateways/[gatewayId].vue")
  },
  {
    name: "settings-payment-gateways-connect-paypal",
    path: "payment-gateways/connect/paypal",
    component: () => import("/opt/buildhome/repo/pages/settings/payment-gateways/connect/paypal.vue")
  },
  {
    name: "settings-payment-gateways-connect-stripe",
    path: "payment-gateways/connect/stripe",
    component: () => import("/opt/buildhome/repo/pages/settings/payment-gateways/connect/stripe.vue")
  },
  {
    name: "settings-payment-gateways-connect-fanbasis",
    path: "payment-gateways/connect/fanbasis",
    component: () => import("/opt/buildhome/repo/pages/settings/payment-gateways/connect/fanbasis.vue")
  }
]
  },
  {
    name: categoriesf4hrQQ3_45PAWdq8HAnXiGms9GEF9CRBVt8oafowiCkKUMeta?.name,
    path: "/categories",
    component: () => import("/opt/buildhome/repo/pages/categories.vue"),
    children: [
  {
    name: "categories",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/categories/index.vue")
  },
  {
    name: "categories-categoryId",
    path: ":categoryId()",
    component: () => import("/opt/buildhome/repo/pages/categories/[categoryId].vue")
  },
  {
    name: "categories-create-salesChannelId",
    path: "create/:salesChannelId()",
    component: () => import("/opt/buildhome/repo/pages/categories/create/[salesChannelId].vue")
  }
]
  },
  {
    name: fulfilmentyY0PrviRLZm0RVETs1JRNPwQlAbf1wc5LOEybjyKjhAMeta?.name,
    path: "/fulfilment",
    component: () => import("/opt/buildhome/repo/pages/fulfilment.vue"),
    children: [
  {
    name: "fulfilment",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/fulfilment/index.vue")
  },
  {
    name: "fulfilment-fulfilled",
    path: "fulfilled",
    component: () => import("/opt/buildhome/repo/pages/fulfilment/fulfilled.vue")
  }
]
  },
  {
    name: "auth-logout",
    path: "/auth/logout",
    component: () => import("/opt/buildhome/repo/pages/auth/logout.vue")
  },
  {
    name: enhancementsy3JkNFUsNetBOJhqroMKA3_45wZtMlJl9uT4XU7w2z3t0Meta?.name,
    path: "/enhancements",
    component: () => import("/opt/buildhome/repo/pages/enhancements.vue"),
    children: [
  {
    name: "enhancements",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/enhancements/index.vue")
  },
  {
    name: "enhancements-create",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/enhancements/create.vue")
  },
  {
    name: "enhancements-enhancementId",
    path: ":enhancementId()",
    component: () => import("/opt/buildhome/repo/pages/enhancements/[enhancementId].vue")
  }
]
  },
  {
    name: "auth-settings",
    path: "/auth/settings",
    component: () => import("/opt/buildhome/repo/pages/auth/settings.vue")
  },
  {
    name: "terminal",
    path: "/terminal",
    component: () => import("/opt/buildhome/repo/pages/terminal/index.vue")
  },
  {
    name: "analytics",
    path: "/analytics",
    component: () => import("/opt/buildhome/repo/pages/analytics/index.vue")
  },
  {
    name: "discounts",
    path: "/discounts",
    component: () => import("/opt/buildhome/repo/pages/discounts/index.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/opt/buildhome/repo/pages/auth/login/index.vue")
  },
  {
    name: "account-suspended",
    path: "/account-suspended",
    component: () => import("/opt/buildhome/repo/pages/account-suspended.vue")
  },
  {
    name: "invitation-invalid",
    path: "/invitation/invalid",
    component: () => import("/opt/buildhome/repo/pages/invitation/invalid.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    component: () => import("/opt/buildhome/repo/pages/auth/reset-password.vue")
  },
  {
    name: "terminal-redeem",
    path: "/terminal/redeem",
    component: () => import("/opt/buildhome/repo/pages/terminal/redeem/index.vue")
  },
  {
    name: "terminal-auth-settings",
    path: "/terminal/auth/settings",
    component: () => import("/opt/buildhome/repo/pages/terminal/auth/settings.vue")
  },
  {
    name: "discounts-create-type",
    path: "/discounts/create/:type()",
    component: () => import("/opt/buildhome/repo/pages/discounts/create/[type].vue")
  },
  {
    name: "account-pending-deletion",
    path: "/account-pending-deletion",
    component: () => import("/opt/buildhome/repo/pages/account-pending-deletion.vue")
  },
  {
    name: "auth-login-accountSlug",
    path: "/auth/login/:accountSlug()",
    component: () => import("/opt/buildhome/repo/pages/auth/login/[accountSlug].vue")
  },
  {
    name: "invitation-invitationId",
    path: "/invitation/:invitationId()",
    component: () => import("/opt/buildhome/repo/pages/invitation/[invitationId].vue")
  },
  {
    name: "terminal-sell-type",
    path: "/terminal/sell/:type()",
    component: () => import("/opt/buildhome/repo/pages/terminal/sell/[type]/index.vue")
  },
  {
    name: "auth-request-password-reset",
    path: "/auth/request-password-reset",
    component: () => import("/opt/buildhome/repo/pages/auth/request-password-reset.vue")
  },
  {
    name: "terminal-redeem-reference",
    path: "/terminal/redeem/:reference()",
    component: () => import("/opt/buildhome/repo/pages/terminal/redeem/[reference].vue")
  },
  {
    name: "discounts-discountId-codes",
    path: "/discounts/:discountId()/codes",
    component: () => import("/opt/buildhome/repo/pages/discounts/[discountId]/codes.vue")
  },
  {
    name: "discounts-discountId",
    path: "/discounts/:discountId()",
    component: () => import("/opt/buildhome/repo/pages/discounts/[discountId]/index.vue")
  },
  {
    name: "terminal-redeem-confirmation",
    path: "/terminal/redeem/confirmation",
    component: () => import("/opt/buildhome/repo/pages/terminal/redeem/confirmation.vue")
  },
  {
    name: "auth-reset-password-confirmation",
    path: "/auth/reset-password-confirmation",
    component: () => import("/opt/buildhome/repo/pages/auth/reset-password-confirmation.vue")
  },
  {
    name: "auth-invalid-password-reset-token",
    path: "/auth/invalid-password-reset-token",
    component: () => import("/opt/buildhome/repo/pages/auth/invalid-password-reset-token.vue")
  },
  {
    name: "auth-verify-email-userId-hash",
    path: "/auth/verify-email/:userId()/:hash()",
    component: () => import("/opt/buildhome/repo/pages/auth/verify-email/[userId]/[hash].vue")
  },
  {
    name: "discounts-discountId-group-create",
    path: "/discounts/:discountId()/group/create",
    component: () => import("/opt/buildhome/repo/pages/discounts/[discountId]/group/create.vue")
  },
  {
    name: "auth-request-password-reset-confirmation",
    path: "/auth/request-password-reset-confirmation",
    component: () => import("/opt/buildhome/repo/pages/auth/request-password-reset-confirmation.vue")
  },
  {
    name: "discounts-discountId-group-groupIndex",
    path: "/discounts/:discountId()/group/:groupIndex()",
    component: () => import("/opt/buildhome/repo/pages/discounts/[discountId]/group/[groupIndex].vue")
  },
  {
    name: "discounts-create-per-product-group-create",
    path: "/discounts/create/per-product/group/create",
    component: () => import("/opt/buildhome/repo/pages/discounts/create/per-product/group/create.vue")
  },
  {
    name: "terminal-redeem-voucher-reference",
    path: "/terminal/redeem/voucher/:reference()",
    component: () => import("/opt/buildhome/repo/pages/terminal/redeem/voucher/[reference]/index.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId",
    path: "/terminal/sell/:type()/:salesChannelId()",
    component: () => import("/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/index.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-summary",
    path: "/terminal/sell/:type()/:salesChannelId()/summary",
    component: () => import("/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/summary.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-waiting",
    path: "/terminal/sell/:type()/:salesChannelId()/waiting",
    component: () => import("/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/waiting.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-complete",
    path: "/terminal/sell/:type()/:salesChannelId()/complete",
    component: () => import("/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/complete.vue")
  },
  {
    name: "terminal-redeem-voucher-reference-redeemableId",
    path: "/terminal/redeem/voucher/:reference()/:redeemableId()",
    component: () => import("/opt/buildhome/repo/pages/terminal/redeem/voucher/[reference]/[redeemableId].vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-delivery-post",
    path: "/terminal/sell/:type()/:salesChannelId()/delivery/post",
    component: () => import("/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/delivery/post.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-delivery-email",
    path: "/terminal/sell/:type()/:salesChannelId()/delivery/email",
    component: () => import("/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/delivery/email.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-delivery",
    path: "/terminal/sell/:type()/:salesChannelId()/delivery",
    component: () => import("/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/delivery/index.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-delivery-collect",
    path: "/terminal/sell/:type()/:salesChannelId()/delivery/collect",
    component: () => import("/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/delivery/collect.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-p-productId",
    path: "/terminal/sell/:type()/:salesChannelId()/p/:productId()",
    component: () => import("/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/index.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-p-productId-variant",
    path: "/terminal/sell/:type()/:salesChannelId()/p/:productId()/variant",
    component: () => import("/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/variant.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-p-productId-monetary",
    path: "/terminal/sell/:type()/:salesChannelId()/p/:productId()/monetary",
    component: () => import("/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/monetary.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-p-productId-enhancements",
    path: "/terminal/sell/:type()/:salesChannelId()/p/:productId()/enhancements",
    component: () => import("/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/enhancements.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-p-productId-product-info",
    path: "/terminal/sell/:type()/:salesChannelId()/p/:productId()/product-info",
    component: () => import("/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/product-info.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-p-productId-personalisation",
    path: "/terminal/sell/:type()/:salesChannelId()/p/:productId()/personalisation",
    component: () => import("/opt/buildhome/repo/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/personalisation.vue")
  }
]